export interface ImageData {
    height: number;
    width: number;
    mimetype: string;
    thumbnail: string;
}

export const getImageMetadata = async (image: File): Promise<ImageData> => {
    return new Promise((resolve, reject) => {
        const imageUrl = URL.createObjectURL(image);

        const imgElement = new Image();
        imgElement.src = imageUrl;

        imgElement.onload = () => {
            const width = imgElement.width;
            const height = imgElement.height;

            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext('2d');
            context?.drawImage(imgElement, 0, 0, width, height);
            const thumbnail = canvas.toDataURL('image/png');

            // Free up memory by revoking object URL
            URL.revokeObjectURL(imageUrl);

            const mimetype = image.type;

            resolve({
                height,
                mimetype,
                thumbnail,
                width,
            });
        };

        imgElement.onerror = () => {
            reject(new Error('Failed to load image'));
        };
    });
};
